module.exports = __webpack_public_path__ + "static/2-e8688854318cfcd8f624c082ddee2ae2.jpg";